import { createAction, createSlice } from "@reduxjs/toolkit";

const updateUserActiveSlice = createSlice({
  name: "updateUserActive",
  initialState: { success: null, processing: false },
  reducers: {
    pending(state) {
      state.success = null;
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = null;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = updateUserActiveSlice;
const updateUserActiveAction = createAction(name);

export {
  updateUserActiveAction,
  actions as updateUserActiveActions,
  reducer as updateUserActiveReducer,
};
